import React, { useState, useEffect } from "react";
import { handleRegionChange } from "../../utils/regionUtils";
import ClosePopupIcon from "../../images/geolocation/close-popup-icon.svg";
import globalStrings from "../../config";

const GeolocationPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { message, buttonYes, buttonNo } = globalStrings.geolocation.popup;
  const apiRegionUrl = "https://ipwhois.app/json/";
  const europeCode = "EU";

  useEffect(() => {
    const checkRegion = async () => {
      try {
        const pathname = window.location.pathname;
        if (pathname.startsWith("/emea")) {
          return;
        }

        const hasVisited = localStorage.getItem("hasVisitedPopup");
        if (hasVisited) {
          return;
        }

        const response = await fetch(apiRegionUrl);
        const data = await response.json();
        if (data && data.continent_code === europeCode) {
          setIsVisible(true);
        }
      } catch (error) {
        console.error("Failed to fetch geolocation data:", error);
      }
    };

    checkRegion().catch((error) => {
      console.error("Unhandled error in checkRegion:", error);
    });
  }, []);

  const onClose = () => {
    setIsVisible(false);
    localStorage.setItem("hasVisitedPopup", "true");
  };

  if (!isVisible) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-25 flex justify-center items-center z-[9999]"
      role="dialog"
      aria-labelledby="geolocation-popup-title"
      aria-describedby="geolocation-popup-description"
      aria-modal="true"
    >
      <div
        className="w-[796px] h-[338px] bg-white rounded-[16px] relative p-[40px_50px] text-center flex flex-col justify-center shadow-[0px_8px_20px_rgba(0,0,0,0.15)] max-md:w-[90%] max-md:p-[16px] max-sm:p-[12px]"
        role="document"
      >
        <h2
          id="geolocation-popup-title"
          className="text-[32px] font-bold leading-[40px] my-[64px] max-md:text-[18px] max-md:text-center max-sm:text-[18px]"
        >
          {message}
        </h2>
        <p id="geolocation-popup-description" className="sr-only">
          This popup allows you to select your region.
        </p>

        <div className="flex justify-center gap-[24px] max-md:flex-col max-md:gap-[8px]">
          <button
            className="p-[16px] text-[14px] leading-[21px] font-bold rounded-[4px] border border-[#333] cursor-pointer max-md:w-full"
            onClick={onClose}
            aria-label="Stay on the global site"
          >
            {buttonNo}
          </button>

          <button
            className="p-[16px] text-[14px] font-bold leading-[21px] rounded-[4px] border-none cursor-pointer bg-[#FF8E2F] text-white max-md:w-full"
            onClick={() => handleRegionChange("emea")}
            aria-label="Go to the EMEA site"
          >
            {buttonYes}
          </button>
        </div>
        <button
          className="absolute top-[50px] right-[40px] cursor-pointer max-md:top-[20px] max-md:right-[20px]"
          onClick={onClose}
          aria-label="Close popup"
        >
          <img src={ClosePopupIcon} alt="Close popup" />
        </button>
      </div>
    </div>
  );
};

export default GeolocationPopup;
